import { render, staticRenderFns } from "./SurrenderRosterEdit.vue?vue&type=template&id=0688e71c&scoped=true&"
import script from "./SurrenderRosterEdit.vue?vue&type=script&lang=js&"
export * from "./SurrenderRosterEdit.vue?vue&type=script&lang=js&"
import style0 from "./SurrenderRosterEdit.vue?vue&type=style&index=0&id=0688e71c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0688e71c",
  null
  
)

export default component.exports